/**
 * @generated SignedSource<<1a9907dfb241a1da3f63cf40d6245652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
export type DiningAgendaScreenQuery$variables = Record<PropertyKey, never>;
export type DiningAgendaScreenQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly facilities: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly courses: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly id: string;
                      readonly name: string;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly department: {
                  readonly type: DepartmentType;
                } | null | undefined;
                readonly id: string;
                readonly maxMultipleBookings: number | null | undefined;
                readonly memberBookingWindowDays: number | null | undefined;
                readonly multipleBookingsEnabled: boolean;
                readonly name: string;
                readonly slug: string;
                readonly " $fragmentSpreads": FragmentRefs<"AgendaDateSelectorControlFragment_facility" | "TeeSheetBasedFiltersModalFragment_facility" | "facilityToScheduleOption_facility">;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaHeaderDesktopNewFragment_club" | "TeeSheetAgendaHeaderMobileNewFragment_club" | "useGetClubStartOfWeekNumberPatron_club">;
        };
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  } | null | undefined;
};
export type DiningAgendaScreenQuery = {
  response: DiningAgendaScreenQuery$data;
  variables: DiningAgendaScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Department",
  "kind": "LinkedField",
  "name": "department",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxMultipleBookings",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberBookingWindowDays",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "multipleBookingsEnabled",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarStartDay",
  "storageKey": null
},
v11 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v0/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DiningAgendaScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ScheduleSwitcher_session"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TeeSheetAgendaHeaderDesktopNewFragment_club"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TeeSheetAgendaHeaderMobileNewFragment_club"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "useGetClubStartOfWeekNumberPatron_club"
                      },
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineDataFragmentSpread",
                                    "name": "facilityToScheduleOption_facility",
                                    "selections": [
                                      (v0/*: any*/),
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "args": null,
                                    "argumentDefinitions": []
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TeeSheetBasedFiltersModalFragment_facility"
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AgendaDateSelectorControlFragment_facility"
                                  },
                                  (v0/*: any*/),
                                  (v2/*: any*/),
                                  (v1/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseConnection",
                                    "kind": "LinkedField",
                                    "name": "courses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Course",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v0/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DiningAgendaScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v0/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v0/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportsPublic",
                                        "storageKey": null
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PublicBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "publicBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v11/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PrivateBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "privateBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v11/*: any*/),
                                    "storageKey": null
                                  },
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v0/*: any*/),
                                      (v1/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayNameOrFacilityName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityStartEndTime",
                                    "kind": "LinkedField",
                                    "name": "startEndTime",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "bookingType",
                                        "value": "STANDARD"
                                      }
                                    ],
                                    "concreteType": "GroupSize",
                                    "kind": "LinkedField",
                                    "name": "minMaxGroupSize",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "min",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "max",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
                                  },
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseConnection",
                                    "kind": "LinkedField",
                                    "name": "courses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Course",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v0/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publicBookingWindowDays",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseLayoutConnection",
                                    "kind": "LinkedField",
                                    "name": "courseLayouts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseLayoutEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseLayout",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "enabled",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "holeCount",
                                                "storageKey": null
                                              },
                                              (v0/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "publicId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "renderingKey",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "62f972ceece079f62230e19ced77c7bb",
    "id": null,
    "metadata": {},
    "name": "DiningAgendaScreenQuery",
    "operationKind": "query",
    "text": "query DiningAgendaScreenQuery {\n  session {\n    ...ScheduleSwitcher_session\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        club {\n          ...TeeSheetAgendaHeaderDesktopNewFragment_club\n          ...TeeSheetAgendaHeaderMobileNewFragment_club\n          ...useGetClubStartOfWeekNumberPatron_club\n          id\n          facilities {\n            edges {\n              node {\n                ...facilityToScheduleOption_facility\n                ...TeeSheetBasedFiltersModalFragment_facility\n                ...AgendaDateSelectorControlFragment_facility\n                id\n                name\n                slug\n                maxMultipleBookings\n                memberBookingWindowDays\n                multipleBookingsEnabled\n                courses {\n                  edges {\n                    node {\n                      name\n                      id\n                    }\n                  }\n                }\n                department {\n                  type\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment AgendaDateSelectorControlFragment_facility on Facility {\n  id\n  publicBookingWindowDays\n  memberBookingWindowDays\n  club {\n    supportsPrivate\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment ScheduleSwitcher_session on Session {\n  ...useGetScheduleSwitcherOptionsFragment_session\n}\n\nfragment TeeSheetAgendaHeaderDesktopNewFragment_club on Club {\n  name\n  ...FacilityLogoFragment_club\n}\n\nfragment TeeSheetAgendaHeaderMobileNewFragment_club on Club {\n  name\n  ...FacilityLogoFragment_club\n  supportsPrivate\n  logoImage {\n    publicId: renderingKey\n  }\n  facilities {\n    edges {\n      node {\n        id\n        name\n        displayNameOrFacilityName\n        slug\n      }\n    }\n  }\n}\n\nfragment TeeSheetBasedFiltersModalFragment_facility on Facility {\n  id\n  club {\n    supportsPrivate\n    id\n  }\n  ...useFacilityStartEndTime_facility\n  ...useFacilityGroupSize_facility\n  ...TeeSheetCourseSelectorControlFragment_facility\n  ...TeeSheetMultipleBookingToggleFragment_Facility\n  ...AgendaDateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n  ...TeeSheetHoleCountSelectorControl_facility\n}\n\nfragment TeeSheetCourseSelectorControlFragment_facility on Facility {\n  id\n  name\n  slug\n  multipleBookingsEnabled\n  courses {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment TeeSheetHoleCountSelectorControl_facility on Facility {\n  id\n  courseLayouts {\n    edges {\n      node {\n        enabled\n        holeCount\n        id\n      }\n    }\n  }\n}\n\nfragment TeeSheetMultipleBookingToggleFragment_Facility on Facility {\n  multipleBookingsEnabled\n}\n\nfragment departmentToScheduleOption_department on Department {\n  type\n  id\n  slug\n  name\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useFacilityGroupSize_facility on Facility {\n  minMaxGroupSize(bookingType: STANDARD) {\n    min\n    max\n  }\n}\n\nfragment useFacilityStartEndTime_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetScheduleSwitcherOptionsFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              type\n              id\n              ...getFacilityMemberPermissions_facility\n              ...facilityToScheduleOption_facility\n              department {\n                id\n                type\n                ...departmentToScheduleOption_department\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "390da5c54e71361d3ee9c9ae05e1a06a";

export default node;
